import { Flex, Typography } from '@banhala/ui-kit';
import { Pressable, View } from 'react-native';
import React from 'react';

type Props = {
  isEditMode: boolean;
  onEdit: () => void;
  onClose: () => void;
  onClearAll: () => void;
};

export const RecentHeader = ({
  isEditMode,
  onEdit,
  onClose,
  onClearAll,
}: Props) => {
  return (
    <Flex.Row
      alignItems="center"
      justifyContent="space-between"
      padding={{ horizontal: 16 }}
      height={44}
    >
      {/* 제목이 가용 너비를 점유하도록 flex={1} (Fabric에서 flex 없는 Text가 너비 과소할당되어
          공간이 남아도 말줄임되는 것 방지). numberOfLines={1}은 큰 글꼴 시 개행 방지용 (ENABLE-1109) */}
      <Flex flex={1}>
        <Typography type="subtitle1" numberOfLines={1}>
          최근 검색어
        </Typography>
      </Flex>
      <Flex.Row alignItems="center">
        {isEditMode ? (
          <>
            <Pressable onPress={onClearAll}>
              <Typography type="body3" color="content_secondary">
                전체삭제
              </Typography>
            </Pressable>
            <View
              style={{
                width: 1,
                height: 14,
                backgroundColor: '#D8D8D8',
                marginHorizontal: 8,
              }}
            />
            <Pressable onPress={onClose}>
              <Typography type="body3" color="content_secondary">
                닫기
              </Typography>
            </Pressable>
          </>
        ) : (
          <Pressable onPress={onEdit}>
            <Typography type="body3" color="content_secondary">
              편집
            </Typography>
          </Pressable>
        )}
      </Flex.Row>
    </Flex.Row>
  );
};
